import { Button, Grid } from "@mui/material";

type Props = {
  label: string;
};

export const ProcessCodeTag = ({ label }: Props) => {
  return (
    <Grid container justifyContent="center">
      <Grid item md={12}>
        <Button
          variant="contained"
          sx={{
            minWidth: "24px",
            height: "24px",
            padding: "6px 8px",
            cursor: "auto",
            backgroundColor: "#FF7043",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#F4511E",
            },
          }}
          title={`${label} Last Probe`}
        >
          {label}
        </Button>
      </Grid>
    </Grid>
  );
};
